export const addFormData = (formData) => {
    return {
        type: 'ADD-FORM-DATA',
        payload: formData
    };
};

export const updateDefaultFlag = (isDefault) => {
    return {
        type: 'UPDATE-DEFAULT-FLAG',
        payload: isDefault
    };
}

export const clearFormData = () => {
    return {
        type: 'CLEAR-FORM-DATA'
    };
};
